export const validateEmail = (email: string) => {
  if (!email) return false;

  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};

export const isGmail = (email: string) => {
  if (!email) return false;

  return email.endsWith('@gmail.com');
};

export const validatePassword = (password: string) => {
  if (!password) {
    return;
  }

  const isLongEnough = password.length >= 8;
  const hasNumber = /\d/.test(password);
  const hasLetter = /[a-z]/.test(password);
  const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return isLongEnough && hasNumber && hasLetter && hasSymbol;
};

export const passwordsValidAndMatch = (
  password: string,
  confirmPassword: string,
): boolean => {
  if (!password || !confirmPassword) return false;

  if (
    password.length > 0 &&
    confirmPassword.length > 0 &&
    validatePassword(password) &&
    validatePassword(confirmPassword) &&
    password === confirmPassword
  ) {
    return true;
  } else {
    return false;
  }
};

export const getDayArray = (year: number, month: number) => {
  const dayCount = new Date(year, month, 0).getDate();
  return Array.from({ length: dayCount }, (_, i) =>
    String(i + 1).padStart(2, '0'),
  );
};

export const isValidDate = (dateStr: string) => {
  // MMDDYYYY 형태의 정규식
  const regex = /^(\d{2})(\d{2})(\d{4})$/;
  const match = dateStr.match(regex);
  if (!match) return false;

  const month = parseInt(match[1], 10) - 1;
  const day = parseInt(match[2], 10);
  const year = parseInt(match[3], 10);

  const date = new Date(year, month, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month ||
    date.getDate() !== day
  ) {
    return false;
  }

  return true;
};

export const isOver13YearsOld = (dateStr: string) => {
  if (!isValidDate(dateStr)) {
    return false;
  }

  // 현재 날짜와 사용자의 생일 날짜 객체 생성
  const currentDate = new Date();
  // MMDDYYYY 형태의 정규식
  const regex = /^(\d{2})(\d{2})(\d{4})$/;
  const match = dateStr.match(regex);
  if (!match) return false;

  const month = parseInt(match[1], 10) - 1;
  const day = parseInt(match[2], 10);
  const year = parseInt(match[3], 10);

  const date = new Date(year, month, day);

  // 나이 계산
  let age = currentDate.getFullYear() - date.getFullYear();
  const m = currentDate.getMonth() - date.getMonth();
  if (m < 0 || (m === 0 && currentDate.getDate() < date.getDate())) {
    age--;
  }

  // 13살 이상인지 확인
  return age >= 13;
};

export const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}-${day}-${year}`;
};
